/** @jsxRuntime classic */
/** @jsx jsx */
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { jsx } from "theme-ui";

import Cellar from "./Cellar";
import Header from "./Header";
import api, { errorMessage } from "../utils/api";
import { retrieveAuth } from "../utils/auth";

export default function AdminCellar() {
  const { uuid } = useParams();
  const [user, setUser] = useState({});
  const [auth, setAuth] = useState({});
  const [cellarOwner, setCellarOwner] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deposits, setDeposits] = useState([]);
  const url = `/api/admin/user/${uuid}/deposits/`;

  const fetchCellar = () => {
    const auth = retrieveAuth();
    if (!auth) return;
    setUser(auth.user);
    setAuth(auth.token);

    api
      .get(url)
      .then((response) => {
        setLoading(false);
        setDeposits(response.data.results);
        setCellarOwner(response.data.metadata.user);
      })
      .catch((error) => {
        // Without clearing loading here the spinner ran forever.
        setLoading(false);
        setError(errorMessage(error, "We couldn't load this cellar."));
      });
  };

  useEffect(() => {
    fetchCellar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      sx={{
        minHeight: "100vh",
      }}
    >
      <Header user={user} isAdmin />

      <div
        sx={{
          px: [10, 50],
          pb: [10, 50],
        }}
      >
        {error ? (
          <div
            sx={{
              variant: "components.flexCenter",
              width: "100%",
              height: "calc(100vh - 140px)",
              color: "error",
            }}
          >
            {error}
          </div>
        ) : !loading ? (
          <Cellar
            deposits={deposits}
            token={auth.token}
            user={user}
            isAdmin={true}
            cellarOwner={cellarOwner}
            uuid={uuid}
            fetchCellar={fetchCellar}
          />
        ) : (
          <div
            sx={{
              variant: "components.flexCenter",
              width: "100%",
              height: "calc(100vh - 140px)",
            }}
          >
            <span>
              <div className="loader"></div>
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
